import AxiosInstance from "./components/Axios";

const project_id = localStorage.getItem('project_id');

export const fetchVariableValues = async (variableName) => {
  try {
    const response = await AxiosInstance.get(`projects/${project_id}/variables_socialmedia/`, { params: { name: variableName } });
    if (response.data.length > 0) {
      console.log('data vars', response.data);
      const variable = response.data.find(v => v.name === variableName);
      if (variable) {
        return { values: variable.values, error: null };
      } else {
        return { values: [], error: `No values found for ${variableName}` };
      }
    } else {
      return { values: [], error: `No values found for ${variableName}` };
    }
  } catch (error) {
    console.error(error);
    return { values: [], error: `An error occurred while fetching values for ${variableName}` };
  }
};
